import {EnumValidValueItemModel} from '../../../../../models/enum/enum-valid-value-item.model';
import {DocumentDataModel} from '../../../../../models/document/document-data.model';
import {DocumentInFolderDataModel} from '../../../../../models/document/document-in-folder-data.model';

export class TdoOrganizerCategorizeModel {
  documentTagOptions: EnumValidValueItemModel[];
  documents: DocumentDataModel[];
}
